'use strict';

wbApp.directive('wbRentCategoryGroupCombo', ['$timeout', '$translate', 'rentCategoryGroupSvc',
    function ($timeout, $translate, rentCategoryGroupSvc) {
        function formatResult(model) {
            if (!model) {
                return "";
            }

            return model.name;
        }

        function formatSelection(model) {
            return model.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            scope: {
                allowClear: '='
            },
            link: function (scope, elm, attrs, controller) {

                var models = rentCategoryGroupSvc.getAll();
                models.$promise.then(function () {
                    if (models.length == 1) {
                        $(elm).select2('val', models[0].id);
                        controller.$setViewValue(models[0].id);
                    }
                });

                models.$promise.then(function () {
                    $timeout(function () {

                        $(elm).select2({
                            placeholder: $translate.instant('TXT_MENU_RENT_CATEGORY_GROUP'),
                            formatResult: formatResult,
                            formatSelection: formatSelection,
                            dropdownAutoWidth: true,
                            allowClear: (typeof scope.allowClear !== 'undefined') ? scope.allowClear : true,
                            minimumResultsForSearch: -1,
                            id: function (model) { return model.id; },
                            data: models
                        });

                        controller.$render();
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    controller.$render();
                }, 1);
            }
        }
    }]);